import {
    GiBasketballBall,
    GiAmericanFootballBall,
    GiSoccerBall,
    GiVolleyballBall,
    GiTennisBall,
    GiBaseballGlove,
  } from 'react-icons/gi';
  
  const sportIconMap = {
    basketball: GiBasketballBall,
    football: GiAmericanFootballBall,
    soccer: GiSoccerBall,
    volleyball: GiVolleyballBall,
    tennis: GiTennisBall,
    baseball: GiBaseballGlove,
  };
  
  const SportIcon = ({ sport, size = 48, color = 'var(--text-main)', style = {} }) => {
    const IconComponent = sportIconMap[sport];
  
    if (!IconComponent) return null;
  
    return <IconComponent size={size} color={color} style={style} />;
  };
  
  export default SportIcon;  